import React from 'react';
import { Link } from 'react-router-dom';

export type AdminTab = 'overview' | 'content' | 'accounts' | 'settings' | 'sessions' | 'backup';

interface AdminNavProps {
  currentTab: AdminTab;
  onTabChange: (tab: AdminTab) => void;
  onOpenPreview: () => void;
  onLogout: () => void;
}

export const AdminNav: React.FC<AdminNavProps> = ({
  currentTab,
  onTabChange,
  onOpenPreview,
  onLogout,
}) => {
  const tabs: Array<{ id: AdminTab; label: string }> = [
    { id: 'overview', label: 'Overview' },
    { id: 'content', label: 'Content' },
    { id: 'accounts', label: 'Accounts' },
    { id: 'settings', label: 'Settings' },
    { id: 'sessions', label: 'Sessions' },
    { id: 'backup', label: 'Backup & Import' },
  ];

  return (
    <header className="admin-header">
      <div className="admin-header-main">
        <div className="admin-brand">
          <Link to="/" className="admin-brand-link" title="View Heart">
            heart
          </Link>
          <span className="admin-badge">Admin</span>
        </div>

        <nav className="admin-nav-tabs" aria-label="Admin tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              className={`nav-tab-btn ${currentTab === tab.id ? 'active' : ''}`}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="admin-header-actions">
          <button
            type="button"
            className="action-btn action-btn-preview"
            onClick={onOpenPreview}
          >
            Live Preview
          </button>
          <button
            type="button"
            className="action-btn action-btn-logout"
            onClick={onLogout}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
};
